import { ZonedDateTimeFactory, zonedSubtractDuration } from '@csp/csp-common-date-util';
import { MetricPeriod, MetricPeriodUnitType } from '@csp/csp-common-model';

const toDays = ({ amount, unit }: MetricPeriod, daysPerMonth: number): number => {
  const day = amount;
  switch (unit) {
    case MetricPeriodUnitType.DAY:
      return day;
    case MetricPeriodUnitType.WEEK:
      return day * 7;
    case MetricPeriodUnitType.MONTH:
      return day * daysPerMonth;
    case MetricPeriodUnitType.YEAR:
      return day * 365;
    default:
      throw new Error(`Non supported period unit: ${unit}`);
  }
};

const periodToMillis = (metricPeriod: MetricPeriod, daysPerMonth: number): number => {
  const now = ZonedDateTimeFactory.now();
  const inPast = zonedSubtractDuration(now, { days: toDays(metricPeriod, daysPerMonth) });
  return now.unixTimeMillis - inPast.unixTimeMillis;
};

export const MetricPeriodUtil = {
  periodToMillis,
};
